import Vue from "vue";
import Router from "vue-router";
import MainPage from '@/views/MainPage.vue';
import AboutPage from '@/views/AboutPage.vue';
import ContactPage from '@/views/ContactPage.vue';
import ContactFormPage from '@/views/ContactFormPage.vue';
import TapPage from '@/views/TapPage.vue'
import DelkoitHtsPage from '@/views/DelkoitHtsPage.vue';
import WebTradingTerminalPage from '@/views/WebTradingTerminalPage.vue';
import MobileTradingTerminalPage from '@/views/MobileTradingTerminalPage.vue';
import OrderManagementSystemPage from '@/views/OrderManagementSystemPage.vue';
import RiskManagementSystemPage from '@/views/RiskManagementSystemPage.vue';
import ShortSellingPage from '@/views/ShortSellingPage.vue';
import DerivativesSimulatorPage from '@/views/DerivativesSimulatorPage.vue';
import AutoTradingPage from '@/views/AutoTradingPage.vue';
import STOPage from '@/views/STOPage.vue';
import TradingSoftwareDevPage from '@/views/TradingSoftwareDevPage.vue';
import AutoTradingSignalPage from '@/views/AutoTradingSignalPage.vue';
//import i18n from "./i18n";

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			//redirect: `/${i18n.locale}`
			component: MainPage,
		},
		{
			path: "/about",
			name: "About",
			component: AboutPage,
		},
		{
			path: "/contact",
			name: "Contact",
			component: ContactPage,
		},
		{
			path: "/contactform",
			name: "ContactForm",
			component: ContactFormPage,
		},
		{
			path: "/tap",
			name: "tap",
			component: TapPage,
		},
		{
			path: "/delkoithts",
			name: "DelkoitHtsPage",
			component: DelkoitHtsPage,
		},
		{
			path: "/webtradingterminal",
			name: "WebTradingTerminalPage",
			component: WebTradingTerminalPage,
		},
		{
			path: "/mobiletradingterminal",
			name: "MobileTradingTerminalPage",
			component: MobileTradingTerminalPage,
		},
		{
			path: "/ordermanagementsystem",
			name: "OrderManagementSystemPage",
			component: OrderManagementSystemPage,
		},
		{
			path: "/riskmanagementsystem",
			name: "RiskManagementSystemPage",
			component: RiskManagementSystemPage,
		},
		{
			path: "/shortselling",
			name: "ShortSellingPage",
			component: ShortSellingPage,
		},
		{
			path: "/derivativessimulator",
			name: "DerivativesSimulatorPage",
			component: DerivativesSimulatorPage,
		},
		{
			path: "/autotrading",
			name: "AutoTradingPage",
			component: AutoTradingPage,
		},
		{
			path: "/sto",
			name: "STOPage",
			component: STOPage,
		},
		{
			path: "/tradingsoftwaredev",
			name: "TradingSoftwareDevPage",
			component: TradingSoftwareDevPage,
		},
		{
			path: "/autotradingsignal",
			name: "AutoTradingSignalPage",
			component: AutoTradingSignalPage,
		},		
		/*
		{
			path: '/:lang',
			component: {
				render (c) { return c('router-view')}
			},
			children: [
				{
					path: "/",
					name: "Main",
					component: MainPage,
				},
				{
					path: "about",
					name: "About",
					component: AboutPage,
				},
				{
					path: "contact",
					name: "Contact",
					component: ContactPage,
				},
				{
					path: "contactform",
					name: "ContactForm",
					component: ContactFormPage,
				},
				{
					path: "tap",
					name: "tap",
					component: TapPage,
				},
				{
					path: "delkoithts",
					name: "DelkoitHtsPage",
					component: DelkoitHtsPage,
				},
				{
					path: "webtradingterminal",
					name: "WebTradingTerminalPage",
					component: WebTradingTerminalPage,
				},
				{
					path: "mobiletradingterminal",
					name: "MobileTradingTerminalPage",
					component: MobileTradingTerminalPage,
				},
				{
					path: "ordermanagementsystem",
					name: "OrderManagementSystemPage",
					component: OrderManagementSystemPage,
				},
				{
					path: "riskmanagementsystem",
					name: "RiskManagementSystemPage",
					component: RiskManagementSystemPage,
				},
				{
					path: "shortselling",
					name: "ShortSellingPage",
					component: ShortSellingPage,
				},
				{
					path: "derivativessimulator",
					name: "DerivativesSimulatorPage",
					component: DerivativesSimulatorPage,
				},
				{
					path: "autotrading",
					name: "AutoTradingPage",
					component: AutoTradingPage,
				},
				{
					path: "sto",
					name: "STOPage",
					component: STOPage,
				},
				{
					path: "tradingsoftwaredev",
					name: "TradingSoftwareDevPage",
					component: TradingSoftwareDevPage,
				},
				{
					path: "autotradingsignal",
					name: "AutoTradingSignalPage",
					component: AutoTradingSignalPage,
				},
			]
		}
		*/
	],
	scrollBehavior () {
		document.getElementById('app').scrollTop = 0
	}
})